import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SidebarAdmin from './sidebaradmin';

import TextField from '@mui/material/TextField';

import {
  Link, useNavigate
} from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { getLocationList, updateStudent } from '../../actions/admin.actions';
import { updateNullOfObjectValues } from '../../helpers/helper';
import secureLocalStorage from 'react-secure-storage';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import { useSelector } from 'react-redux';

import Chip from '@mui/material/Chip';
const EditStudentDetails = ({ handleTabChange }) => {
  const formFields = {
    id: '',
    stuid: '',
    first_name: '',
    last_name: '',
    gender: '',
    dob: '',
    grade: '',
    sp_need: '',
    location_id: '',
    location_id_ser: '',
    location_at_id: '',
    location_at_id_ser: '',

  };
  //const [locations, setLocations] = useState([]);
  const { locations } = useSelector(state => state.userdata);
  const [formValues, setFormValues] = useState(formFields);
  const [formErrors, setFormErrors] = useState(updateNullOfObjectValues(formFields));
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [editStudentData, setEditStudentData] = useState(null);
  const [searchLocValue, setSearchLocValue] = useState(null);
  const [searchLocAtValue, setSearchLocAtValue] = useState(null);
  const navigate = useNavigate();
  React.useEffect(() => {
    if (document.body.classList.contains('adminbody_bg')) {
      document.body.classList.remove('body');
    }
    document.body.classList.add('adminbody_bg');
    //set edit student data if exists
    console.log("ss");
    const editStudentData = secureLocalStorage.getItem('editStudentData');
    console.log(editStudentData);
    if (editStudentData) {
      setFormValues({
        id: editStudentData.id,
        stuid: editStudentData.stuid,
        first_name: editStudentData.student_name,
        last_name: editStudentData.last_name,
        gender: editStudentData.gender,
        dob: editStudentData.disdob,
        grade: editStudentData.stu_grade,
        sp_need: editStudentData.sp_need,
        location_id: editStudentData.location_id,
      
        location_at_id: editStudentData.location_at_id,
       
        school_name: editStudentData.school_name,

      });
     var res=locations.map((item, index) => (
        item.location_id == editStudentData.location_id ? setSearchLocValue(item) : null
        
      ));
      var res=locations.map((item, index) => (
        item.location_id == editStudentData.location_at_id ? setSearchLocAtValue(item) : null
        
      ));
      setIsEdit(true);
   
      setEditStudentData(editStudentData);
      secureLocalStorage.removeItem('editStudentData');
    } else {
      // handleTabChange(null, 0)
    }

    // getLocationList({ all: 1 }).then((res) => {
    //   setLocations(res.data.data.locations);
    // }).catch((error) => {
    //   console.log(error);
    // });

  }, []);



  const handleAutocompleteChange = (value) => {
    if (value != null) {
        console.log(value.locationName);
        setFormValues({
            ...formValues,
            location_id_ser: value,
            location_id: value.location_id,

            location_at_id: value.location_id,
            location_at_id_ser: value,
            school_name: value.locationName,

        });
        setSearchLocValue(value);
        setSearchLocAtValue(value);
    } else {
        setFormValues({
            ...formValues,
            location_id_ser: null,
            location_id: '',

            school_name: '',

        });
        setSearchLocValue(null);
    }

}
const handleAutocompleteAtChange = (value) => {
    if (value != null) {
        console.log(value.locationName);
        setFormValues({
            ...formValues,
            location_at_id_ser: value,

            location_at_id: value.location_id,


        });
        setSearchLocAtValue(value);
    } else {
        setFormValues({
            ...formValues,
            location_at_id_ser: null,


            location_at_id: '',


        });
        setSearchLocAtValue(null);
    }

}

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const handleReset = () => {
    setFormValues(formFields);
    setFormErrors(updateNullOfObjectValues(formFields));
  }

  const handleSubmit = () => {
    if (submitting) return;
    if (validateForm()) {
      setSubmitting(true);
      let formData = { ...formValues };
      const myArray = formValues.dob.split("/");

      var month = myArray[0];
      var day = myArray[1];
      var year = myArray[2];
      var daten = year + '-' + month + '-' + day;
      formData.dob = daten;


      if (isEdit) {
        updateStudent(formData).then((res) => {
          handleSubmitResponse(res);
        }).catch((error) => {
          console.log(error);
        });
      } else {
        handleTabChange(null, 1, null, true,false);
      }

    }
  }

  const handleSubmitResponse = (res) => {
    setSubmitting(false);
    if (res.data.status) {
      setSubmitSuccess(res.data.message);
      setFormValues(formFields);
      setSearchLocValue(null);
      setSearchLocAtValue(null);
      setFormErrors(updateNullOfObjectValues(formFields));
      setTimeout(() => {
        setSubmitSuccess(null);
        handleTabChange(null, 1, null, true,false);
      }, 1000);
    } else {
      setSubmitError(res.data.message);
    }
  }

  const validateForm = () => {
    let errors = {};
    let formIsValid = true;

    if (!formValues.first_name) {
      formIsValid = false;
      errors['first_name'] = 'First Name is required';
    }

    if (!formValues.last_name) {
      formIsValid = false;
      errors['last_name'] = 'Last name is required';
    }

    if (!formValues.gender) {
      formIsValid = false;
      errors['gender'] = 'Gender is required';
    }

    if (!formValues.dob) {
      formIsValid = false;
      errors['dob'] = 'DOB is required';
    }

    if (!formValues.grade) {
      formIsValid = false;
      errors['grade'] = 'Grade is required';
    }
    
    if (!formValues.sp_need) {
      formIsValid = false;
      errors['sp_need'] = 'Special Ed is required';
    }
    if (!formValues.location_id) {
      formIsValid = false;
      errors['location_id'] = 'Location  is required';
  }
  if (!formValues.location_at_id) {
      formIsValid = false;
      errors['location_at_id'] = 'Sports School Location  is required';
  }

    setFormErrors(errors);
    return formIsValid;
  }
  const handleNumChange = (event) => {
    console.log(event.target.value);

    setFormErrors(updateNullOfObjectValues(formFields));
    var user_temp = { ...formValues };
    const charCode = event.which || event.keyCode;

    var value = event.target.value;

    if (value.length <= 10) {
      user_temp.dob = value;
    }

    setFormValues(user_temp);

  }
  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;

    if (charCode != 43 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      // The pressed key is not a number
      setSubmitError('Only Numbers are allowed');
      event.preventDefault();
    }
  }

  const handleAccountChange = (event) => {
    setSubmitError('');

    console.log(event.target.value);
    setFormErrors(updateNullOfObjectValues(formFields));
    var user_temp = { ...formValues };
    const charCode = event.which || event.keyCode;

    if (user_temp.dob && (user_temp.dob.length == 2 || user_temp.dob.length == 5)) {

      user_temp.dob = user_temp.dob + '/';
    }
    user_temp.dob = user_temp.dob;
    setFormValues(user_temp);


  }
  const handleKeypress = (e) => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
      e.preventDefault();
      handleSubmit();

    }
  };
  const studentTypeList = [
    { lable: 'Female', value: 'Female' },
    { lable: 'Male', value: 'Male' }
  ]


  return (
    <div className='row'>
      <div className='col-md-12'>
        <div className='club-sec application-sec'>
          <div className='container-fluid '>


            <div className='form-table-sec table-section-route table-form appl-sec  admin-top-sec ad-usr-edit' style={{ marginTop: '5px' }}>
              <div className='row margn-tp-mange-usr'>


                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Student I'd" variant="standard" className='requireds'



                        value={formValues.stuid}

                      />

                    </Box>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="First Name" variant="standard" className='requireds'

                        onChange={handleChange}
                        name="first_name"
                        value={formValues.first_name}
                        error={formErrors.first_name ? true : false}
                        helperText={formErrors.first_name}
                      />

                    </Box>
                  </div>
                </div>

                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Last Name" variant="standard" className='requireds'

                        onChange={handleChange}
                        name="last_name"
                        value={formValues.last_name}
                        error={formErrors.last_name ? true : false}
                        helperText={formErrors.last_name}
                      />

                    </Box>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field margn-avoi-sec edit-dob'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Student DOB" variant="standard" className='requireds'


                        onChange={(e) => handleNumChange(e)}
                        onKeyPress={(e) => { handleAccountChange(e); handleKeypress(e); handleKeyAccountPress(e) }}
                        name="dob"
                        value={formValues.dob}
                        error={formErrors.dob ? true : false}
                        helperText={formErrors.dob}
                        placeholder='MM/DD/YYYY'

                      />


                    </Box>
                  </div>
                </div>
                <div className='col-md-3'>
                                <div className="auto-loca login-secs  login-secsss login-secssss admn-field admn-sel">
                                    {locations.length > 0 &&
                                        <Stack spacing={3} sx={{ width: '100%', margin: '0 auto' }}>
                                            <Autocomplete

                                                id="tags-standard"
                                                value={searchLocValue || null}
                                                options={locations}
                                                getOptionLabel={(option) => option.locationName}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={(event, newValue) => {
                                                    handleAutocompleteChange(newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="standard"
                                                        label="Select Location"
                                                        placeholder="Location" className='requireds'
                                                    />
                                                )}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.locationName}
                                                        </li>
                                                    );
                                                }}
                                                renderTags={(tagValue, getTagProps) => {
                                                    return tagValue.map((option, index) => (
                                                        <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                                                    ))
                                                }}
                                            />
                                            {
                                                formErrors.location_id && <FormHelperText className='manual_error'>{formErrors.location_id}</FormHelperText>
                                            }

                                        </Stack>
                                    }



                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className="auto-loca login-secs  login-secsss login-secssss admn-field admn-sel">
                                    {locations.length > 0 &&
                                        <Stack spacing={3} sx={{ width: '100%', margin: '0 auto' }}>
                                            <Autocomplete

                                                id="tags-standard"
                                                value={searchLocAtValue || null}
                                                options={locations}
                                                getOptionLabel={(option) => option.locationName}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={(event, newValue) => {
                                                    handleAutocompleteAtChange(newValue);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="standard"
                                                        label="Select Sports School Location"
                                                        placeholder="Sports School Location" className='requireds'
                                                    />
                                                )}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.locationName}
                                                        </li>
                                                    );
                                                }}
                                                renderTags={(tagValue, getTagProps) => {
                                                    return tagValue.map((option, index) => (
                                                        <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                                                    ))
                                                }}
                                            />
                                            {
                                                formErrors.location_at_id && <FormHelperText className='manual_error'>{formErrors.location_at_id}</FormHelperText>
                                            }

                                        </Stack>
                                    }



                                </div>
                            </div>

                <div className='col-md-3'>
                  <div className="login-secs login-secsss login-secssss admn-field admn-sel ">
                    <FormControl variant="standard" sx={{ m: 1, width: '90%', margin: '0 auto' }} >
                      <InputLabel id="demo-simple-select-standard-label">Gender<span className='mand-type'>*</span></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formValues.gender}
                        onChange={handleChange}
                        label="Gender"
                        name='gender'
                      >
                        <MenuItem value={'Female'}>Female</MenuItem>
                        <MenuItem value={'Male'}>Male</MenuItem>
                        <MenuItem value={'X'}>X</MenuItem>

                      </Select>
                      {
                        formErrors.type && <FormHelperText className='manual_error'>{formErrors.type}</FormHelperText>
                      }
                    </FormControl>
                  </div>
                </div>


                <div className='col-md-3'>
                  <div className='login-secs login-secsss login-secssss admn-field edt-grd-sec'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="Grade" variant="standard" className='requireds'

                        onChange={handleChange}
                        name="grade"
                        value={formValues.grade}
                        error={formErrors.grade ? true : false}
                        helperText={formErrors.grade}
                      />

                    </Box>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className="login-secs login-secsss login-secssss admn-field admn-sel ">
                    <FormControl variant="standard" sx={{ m: 1, width: '90%', margin: '0 auto' }} >
                      <InputLabel id="demo-simple-select-standard-label">Special  Ed<span className='mand-type'>*</span></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formValues.sp_need}
                        onChange={handleChange}
                        label="Special  Ed"
                        name='sp_need'
                      >
                        <MenuItem value={'Y'}>Yes</MenuItem>
                        <MenuItem value={'N'}>No</MenuItem>
                      </Select>
                      {
                        formErrors.sp_need && <FormHelperText className='manual_error'>{formErrors.sp_need}</FormHelperText>
                      }
                    </FormControl>
                  </div>
                </div>



              </div>

              <div className='row'>
                <div className='col-md-12'>
                  <div class="login-submit login-submitss ">
                    <button class="btn btn-login btn-submit bt-forms" onClick={handleSubmit}>Update
                      {submitting && <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "white" }} />}</button>
                    {/*<button class="btn btn-login btn-submit bt-forms btn-reset">Reset</button>*/}
                  </div>
                </div>
              </div>

              {
                submitSuccess ?
                  <div className="custome-vali custom-success-msg">
                    {submitSuccess}
                  </div>
                  : null
              }
              {
                submitError ?
                  <div className="custome-vali custom-error-msg" >
                    {submitError}
                  </div>
                  : null
              }


            </div>
          </div>
        </div>
      </div>
    </div>

  );
}
export default EditStudentDetails;

